export default __webpack_public_path__ + "static/header-53757c7c097a1ea463f9b4c26590177559469b6561249cb44338a0f60301c6f9.png";